import { Spacer } from "../atoms/Atoms"
import React, { FC, ReactNode } from "react"
import L10n from "../../../lib/carrot-l10n"
import { useSelector } from "react-redux"
import { getIsUsa } from "reducers/userInfo"
import { H2, H4 } from "@carrotfertility/carotene"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type RequestCardWizardHeaderProps = {
  step?: number
  children: ReactNode
}

const RequestCardWizardHeader: FC<RequestCardWizardHeaderProps> = ({ step, children }) => {
  const isUsa = useSelector(getIsUsa)

  return (
    <>
      <H4 variant="primary">{isUsa ? l`carrotCard.getYourCarrotCard` : l`carrotCard.getYourVirtualCarrotCard`}</H4>
      <Spacer height={2} />
      {step && (
        <>
          <H4 variant="secondary">{step === 1 ? l`carrotCard.request.step1of2` : l`carrotCard.request.step2of2`}</H4>
          <Spacer height={0.5} />
        </>
      )}
      <H2>{children}</H2>
      <Spacer height={0.5} />
    </>
  )
}

export default RequestCardWizardHeader
